import { Tabs, TabsContent, TabsControls } from '@wellesley/ui'
import { AppsRoutes, matchPath, useAppsNavigate } from '@wellesley/router'

import { LoginSection } from '../login/LoginSection'
import { SignupProcess } from '../signup/SignupProcess'

const signinPath = '/signin'
const mainSignupPath = '/signup'
const signupPaths: AppsRoutes[] = [mainSignupPath, '/signup/:inviteCode']

export const AuthTabs = () => {
  const value = signupPaths.some((path) => matchPath(path))
    ? mainSignupPath
    : signinPath
  const navigate = useAppsNavigate()
  const handleValueChange = (value: AppsRoutes) => navigate(value)

  return (
    <Tabs
      defaultValue={signinPath}
      value={value}
      onValueChange={handleValueChange}
      className="w-[600px]"
    >
      <TabsControls
        className="!m-0 flex items-center justify-between !gap-0 !px-0 after:hidden [&>*[data-state=active]]:bg-white [&>*[data-state=active]]:text-gray-700 [&>*]:w-full [&>*]:cursor-pointer [&>*]:rounded-tl-lg [&>*]:rounded-tr-lg [&>*]:bg-gray-50 [&>*]:p-m [&>*]:text-center [&>*]:text-lg [&>*]:font-semibold [&>*]:text-blue-600"
        items={[
          {
            value: signinPath,
            label: 'Sign in',
            asChild: true,
            className: 'flex-1',
          },
          {
            value: mainSignupPath,
            label: 'Sign up',
            asChild: true,
            className: 'flex-1',
          },
        ]}
      />
      <div className="w-full rounded-bl-lg rounded-br-lg bg-white">
        <TabsContent value={signinPath}>
          <LoginSection showSignupLink={false} />
        </TabsContent>
        <TabsContent value={mainSignupPath}>
          <SignupProcess />
        </TabsContent>
      </div>
    </Tabs>
  )
}
